interface KpiCardProps {
  label: string;
  value: number | string;
  variant?: 'ok' | 'warning' | 'error';
}

const variantColorMap: Record<NonNullable<KpiCardProps['variant']>, string> = {
  ok: 'text-emerald-600',
  warning: 'text-yellow-600',
  error: 'text-destructive',
};

export function KpiCard({ label, value, variant }: KpiCardProps) {
  const valueColor = variant ? variantColorMap[variant] : '';

  return (
    <div className="border rounded-lg bg-card p-4">
      <p className="text-xs text-muted-foreground mb-1">{label}</p>
      <p className={`text-2xl font-bold tabular-nums ${valueColor}`}>{value}</p>
    </div>
  );
}
